import { createSlice } from '@reduxjs/toolkit';
import { resolveInitialInterfaceMode, INTERFACE_MODES } from '../../helpers/interface-mode';

const interfaceModeSlice = createSlice({
    name: 'interfaceMode',
    initialState: {
        mode: resolveInitialInterfaceMode(),
        isHydrated: true,
    },
    reducers: {
        setInterfaceMode: (state, action) => {
            const nextMode = action.payload.mode;
            if (nextMode === INTERFACE_MODES.BUYER || nextMode === INTERFACE_MODES.SELLER) {
                state.mode = nextMode;
            }
        },
        hydrateInterfaceMode: (state, action) => {
            const nextMode = action.payload.mode;
            if (nextMode === INTERFACE_MODES.BUYER || nextMode === INTERFACE_MODES.SELLER) {
                state.mode = nextMode;
            }
            state.isHydrated = true;
        },
    },
});

export const { setInterfaceMode, hydrateInterfaceMode } = interfaceModeSlice.actions;
export default interfaceModeSlice.reducer;
